<template>
  <div>
    <v-select
      :value="value.wish.comment"
      :items="items"
      label="Anzahl Doppellektionen"
      single-line
      required
      clearable
      v-if="!disabled"
      @change="update"
    ></v-select>
    <span v-else>{{ value.wish.comment || "–" }}</span>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
      default: () => ({ lessons: 0 }),
    },
    wishId: {
      type: Number,
      required: true,
    },
  },
  name: "CourseLessons",

  data() {
    return {};
  },

  computed: {
    items() {
      const result = ["Egal", "Keine DL"];
      for (let i = 1; i <= this.value.lessons / 2; i++) {
        result.push(i - 1 + " - " + i + " DL");
        result.push(i + " DL");
      }
      result.push("Blockunterricht");
      return result;
    },
  },
  methods: {
    update(newValue) {
      if (!newValue) {
        if (this.value.wish.id > 0) {
          this.apiDelete({
            resource: "teacher/wishcourse",
            id: this.value.wish.id,
          });
          this.$emit("update", newValue);
        }
        return;
      }
      this.apiSave({
        resource: "teacher/wishcourse",
        add: this.value.wish.id === 0,
        data: {
          id: this.value.wish.id,
          wish: this.wishId,
          courseId: this.value.id,
          description: this.value.description,
          lessons: this.value.lessons,
          comment: newValue,
        },
      });
      this.$emit("update", newValue);
    },
  },
});
</script>
